import { Link } from 'react-router-dom';

// links: array of { to, label } shown in the main footer-nav row
// legalLinks: array of { to, label } shown in the footer-legal row (omitted if empty)
// showLogo: whether to render the footer logo image (default true)
function Footer({ links = [], legalLinks = [], showLogo = true }) {
  return (
    <footer className="substack-footer">
      <div className="footer-container">
        <div className="footer-top">
          {showLogo && (
            <div className="footer-logo">
              <img
                src="https://daily-obx-cdn.b-cdn.net/newsletter-images/theobxbeachbum%20white.png"
                alt="the OBX Beach Bum"
              />
            </div>
          )}
          <nav className="footer-nav">
            {links.map((link) => (
              <Link key={link.to} to={link.to}>{link.label}</Link>
            ))}
            <Link to="/support">Support the OBX Beach Bum</Link>
          </nav>
        </div>
        <div className="footer-bottom">
          <p className="copyright">© {new Date().getFullYear()} the OBX Beach Bum</p>
          {legalLinks.length > 0 && (
            <div className="footer-legal">
              {legalLinks.map((link) => (
                <Link key={link.to} to={link.to}>{link.label}</Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
